// Zentrale PWA-Installations-Logik.
// Der Browser feuert `beforeinstallprompt` nur einmal und sehr früh.
// Wir fangen das Event global ab (ohne UI) und stellen es für die
// Einstellungen-Seite bereit, damit der Nutzer dort jederzeit installieren kann.

let deferredPrompt = null;
const listeners = new Set();

function notify() {
  listeners.forEach((cb) => {
    try {
      cb();
    } catch (e) {
      console.error("PWA-Install-Listener fehlgeschlagen:", e);
    }
  });
}

export function initInstallPromptCapture() {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferredPrompt = e;
    notify();
  });
  window.addEventListener("appinstalled", () => {
    deferredPrompt = null;
    notify();
  });
}

export function canInstall() {
  return deferredPrompt !== null;
}

export function subscribeInstall(cb) {
  listeners.add(cb);
  return () => listeners.delete(cb);
}

export async function triggerInstall() {
  if (!deferredPrompt) return "unavailable";
  deferredPrompt.prompt();
  let outcome = "dismissed";
  try {
    const result = await deferredPrompt.userChoice;
    outcome = result?.outcome || "dismissed";
  } catch (e) {
    console.error("PWA-Installationsdialog fehlgeschlagen:", e);
  }
  deferredPrompt = null;
  notify();
  return outcome;
}

export function isStandalone() {
  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    window.navigator.standalone === true
  );
}

export function isIOS() {
  return /iphone|ipad|ipod/i.test(navigator.userAgent);
}
